import React, { Component } from "react";
import { Consumer } from "../../context";
import DinamicModal from "../dinamicModal/dinamicModal";
import Request from "../../core/httpClient";
import cogoToast from "cogo-toast";

const request = new Request();

class BudgetPagos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fecha: "",
      banco: "",
      num_movimiento: "",
      monto: 1,
      formasPagos: ["Efectivo", "Transferencia"],
      forma_pago: "Efectivo",
      loadingSave: false,
      message: null,
    };
  }

  resetForm = () => {
    this.setState({
      fecha: "",
      banco: "",
      num_movimiento: "",
      monto: 1,
      forma_pago: "Efectivo",
      message: null,
    });
  };

  handleSubmit = async (event) => {

    event.preventDefault();

    if (parseFloat(this.state.monto) <= 0) {
      cogoToast.error("El monto debe ser mayor a 0.", { position: "bottom-right" });
      return;
    };

    if (!this.state.fecha) {
      cogoToast.error("Debe seleccionar una fecha.", { position: "bottom-right" });
      return;
    };

    this.setState({ loadingSave: true });

    const data = {
      id_factura: this.props.id_factura,
      fecha: this.state.fecha,
      forma_pago: this.state.forma_pago,
      banco: this.state.banco || "",
      num_movimiento: this.state.num_movimiento || "",
      monto: parseFloat(this.state.monto),
      id_usuario: this.props.context.user.id.id_usuario
    };

    const response = await request.post("/facturas/pago/create", data);

    if (response.created && !response.empty) {

      this.props.reload();

      this.resetForm();

      cogoToast.success("Pago agregado.", { position: "bottom-right" });

    } else {

      const errorMsg = response.message || "No se pudo agregar el pago.";

      cogoToast.error(errorMsg, { position: "bottom-right" });
      
      console.error("Error al guardar pago:", response);
    }

    this.setState({ loadingSave: false });
  };

  render() {
    const { fecha, banco, num_movimiento, monto, forma_pago, formasPagos, loadingSave, message } = this.state;
    const { escritura } = this.props;

    return (
      <div>
        <DinamicModal
          idModal={"BudgetPago"}
          sizeModalContainer={"small"}
          title={"Añadir pago"}
          success={this.handleSubmit}
          showBtnSuccess={escritura}
          btnTextSuccess={"GUARDAR"}
          showBtnCancel={true}
          btnTextCancel={"CANCELAR"}
          loadingSave={loadingSave}
          message={message}
        >
          <div className="full row align-center" style={{ padding: "20px" }}>
            <div className="column full">
              <div className="white-space-16" />

              {/* Fecha y Forma de Pago */}
              <div className="input-form-content row full align-center">
                <div className="column label-duo-big">
                  <p><b>Fecha:</b></p>
                </div>
                <div className="column full">
                  <input
                    type="date"
                    name="fecha"
                    className="input input-modals"
                    value={fecha || ""}
                    onChange={(e) => this.setState({ fecha: e.target.value })}
                    required
                  />
                </div>
                <div className="column label-duo-normal align-end">
                  <div className="column label-duo-big">
                    <p><b>F.Pago:</b></p>
                  </div>
                </div>
                <div className="column full">
                  <select
                    className="input input-modals"
                    name="forma_pago"
                    value={forma_pago}
                    onChange={(e) => this.setState({ forma_pago: e.target.value })}
                  >
                    {formasPagos.map((fpago) => (
                      <option key={fpago} value={fpago}>
                        {fpago}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="white-space-16" />

              {/* Banco y N° Movimiento */}
              <div className="input-form-content row full align-center">
                <div className="column label-duo-big">
                  <p><b>Banco:</b></p>
                </div>
                <div className="column full">
                  <input
                    type="text"
                    name="banco"
                    className="input input-modals"
                    autoComplete="off"
                    maxLength="50"
                    value={banco || ""}
                    onChange={(e) => this.setState({ banco: e.target.value })}
                  />
                </div>
                <div className="column label-duo-normal align-end">
                  <div className="column label-duo-big">
                    <p><b>N° Mov:</b></p>
                  </div>
                </div>
                <div className="column full">
                  <input
                    type="text"
                    name="num_movimiento"
                    className="input input-modals"
                    autoComplete="off"
                    maxLength="50"
                    value={num_movimiento || ""}
                    onChange={(e) => this.setState({ num_movimiento: e.target.value })}
                  />
                </div>
              </div>
              <div className="white-space-16" />

              {/* Monto con validación */}
              <div className="input-form-content row full align-center">
                <div className="column label-duo-big">
                  <p><b>Monto:</b></p>
                </div>
                <div className="column full">
                  <input
                    type="number"
                    name="monto"
                    className="input input-modals"
                    value={monto}
                    onChange={(e) => this.setState({ monto: e.target.value })}
                    autoComplete="off"
                    required
                    min="1"
                    step="any"
                  />
                </div>
                <div className="column label-duo-normal align-end">
                  <div className="column label-duo-big">
                    <p></p>
                  </div>
                </div>
                <div className="column full">
                  <div className="column full"></div>
                </div>
              </div>
            </div>
          </div>
        </DinamicModal>
      </div>
    );
  }
}

export default Consumer(BudgetPagos);